import { useLanguage } from "@/hooks/useLanguage";
const PricingHero = () => {
  const { t } = useLanguage();
  return (
    <section className="pt-40 pb-12 md:pt-48 md:pb-16 bg-gradient-to-b from-primary/5 to-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-6 leading-tight">{t("pricing.hero.title")}</h1>
          <p className="text-xl text-muted-foreground">{t("pricing.hero.description")}</p>
        </div>
      </div>
    </section>
  );
};
export default PricingHero;
